//React
import React from "react";


//Material-ui
import Box from '@material-ui/core/Box';

//JSON
var personalityItem = require('../data/personality.json');


const Element = (props) => {
  let element;

  let backgroundColor;
  let borderColor;
  if (props.level === 'main') {
    borderColor = '#B86E00'
    backgroundColor = "#FFE7C2";
  }
  else if (props.level === 'bad') {
    borderColor = '#073E77'
    backgroundColor = "#A6BDD5";
  }
  else if (props.level === 'supply') {
    borderColor = '#920056'
    backgroundColor = "#E7B0D0";
  }
  else if (props.level === 'control') {
    borderColor = '#75AC00'
    backgroundColor = "#E4F7BC";
  }

  element = personalityItem.element.find(item => item.type === props.element);

	return (
		<Box
      className='round12'
      boxShadow={2}
      style={{
        background:backgroundColor,
        borderStyle:'solid',
        borderWidth:'1px',
        borderColor:borderColor,
        padding:'5px',
        height: '2.4em',
        lineHeight: '1.2em',
      }}
    >
      {
        (element) &&
        <div style={{fontSize:'0.9em'}}>{ element.text }</div>
      }
		</Box>
	)
}


class Comp extends React.Component {
  constructor(props) {
		super(props);
    this.state = {
      my: [],
      partner: [],
      canvas:{
        height: 450,
        width: 60,
      },
    }
	}
  componentDidUpdate() {
    if ((this.props.myElement.length === 8) && (this.props.partnerElement.length === 8)) {
        this._drew();
    }
  }

  _drew() {
    let key0 = this.props.partnerElement.findIndex((value) => value === this.props.myElement[0]);
    let key1 = this.props.partnerElement.findIndex((value) => value === this.props.myElement[1]);
    let key2 = this.props.partnerElement.findIndex((value) => value === this.props.myElement[2]);
    let key3 = this.props.partnerElement.findIndex((value) => value === this.props.myElement[3]);
    let key4 = this.props.partnerElement.findIndex((value) => value === this.props.myElement[4]);
    let key5 = this.props.partnerElement.findIndex((value) => value === this.props.myElement[5]);
    let key6 = this.props.partnerElement.findIndex((value) => value === this.props.myElement[6]);
    let key7 = this.props.partnerElement.findIndex((value) => value === this.props.myElement[7]);


    const lrPadding = 4;
    const tbPadding = 20;
    let xStart = lrPadding;
    let xEnd = this.state.canvas.width - lrPadding;

    let yStart = tbPadding;
    let rowHeight = Math.ceil((this.state.canvas.height - (2 * tbPadding)) / 7);

    var ctx = this.refs.canvas.getContext('2d');

    ctx.beginPath();
    ctx.globalAlpha = 0.6;
    ctx.lineWidth = 4;
    ctx.strokeStyle = 'rgb(255, 0, 0)';
    ctx.moveTo(xStart, (yStart + (rowHeight * 0)));
    ctx.lineTo(xEnd, (yStart + (rowHeight * key0)));
    ctx.stroke();

    ctx.beginPath();
    ctx.strokeStyle = 'rgb(255, 128, 0)';
    ctx.moveTo(xStart, (yStart + (rowHeight * 1)));
    ctx.lineTo(xEnd, (yStart + (rowHeight * key1)));
    ctx.stroke();

    ctx.beginPath();
    ctx.strokeStyle = 'rgb(0, 0, 255)';
    ctx.moveTo(xStart, (yStart + (rowHeight * 2)));
    ctx.lineTo(xEnd, (yStart + (rowHeight * key2)));
    ctx.stroke();

    ctx.beginPath();
    ctx.strokeStyle = 'rgb(0, 255, 255)';
    ctx.moveTo(xStart, (yStart + (rowHeight * 3)));
    ctx.lineTo(xEnd, (yStart + (rowHeight * key3)));
    ctx.stroke();

    ctx.beginPath();
    ctx.strokeStyle = 'rgb(255, 0, 255)';
    ctx.moveTo(xStart, (yStart + (rowHeight * 4)));
    ctx.lineTo(xEnd, (yStart + (rowHeight * key4)));
    ctx.stroke();

    ctx.beginPath();
    ctx.strokeStyle = 'rgb(128, 0, 128)';
    ctx.moveTo(xStart, (yStart + (rowHeight * 5)));
    ctx.lineTo(xEnd, (yStart + (rowHeight * key5)));
    ctx.stroke();

    ctx.beginPath();
    ctx.strokeStyle = 'rgb(128, 128, 128)';
    ctx.moveTo(xStart, (yStart + (rowHeight * 6)));
    ctx.lineTo(xEnd, (yStart + (rowHeight * key6)));
    ctx.stroke();

    ctx.beginPath();
    ctx.strokeStyle = 'rgb(64, 64, 64)';
    ctx.moveTo(xStart, (yStart + (rowHeight * 7)));
    ctx.lineTo(xEnd, (yStart + (rowHeight * key7)));
    ctx.stroke();
  }

  render() {
    let tableColHeight = 100;
    return (
      <div style={{maxWidth:'400px', margin:'auto'}}>
        <table width='100%' border='0'>
          <tbody>
            <tr>
              <td align='center' style={{fontSize:'1.4em',fontWeight:'bold'}}>{this.props.myType16}</td>
              <td></td>
              <td align='center' style={{fontSize:'1.4em',fontWeight:'bold'}}>{this.props.partnerType16}</td>
            </tr>
            <tr>
              <td height={tableColHeight}>
                <div align='right'><span className='text_icon' style={{backgroundColor:'#B87A00', fontSize:'0.9em', color:'#FFF'}}>主要</span></div>
                <Element level='main' element={this.props.myElement[0]} />
                <Element level='main' element={this.props.myElement[1]} />
              </td>
              <td rowSpan='8' align='center' style={{verticalAlign: 'center'}}>
                <canvas
                  style={{marginTop:'20px'}}
                  ref="canvas"
                  width={this.state.canvas.width}
                  height={this.state.canvas.height}
                />
              </td>
              <td>
                <span className='text_icon' style={{backgroundColor:'#B87A00', fontSize:'0.9em', color:'#FFF'}}>主要</span>
                <Element level='main' element={this.props.partnerElement[0]} />
                <Element level='main' element={this.props.partnerElement[1]} />
              </td>
            </tr>
            <tr>
              <td height={tableColHeight}>
                <div align='right'><span className='text_icon' style={{backgroundColor:'#073E77', fontSize:'0.9em', color:'#FFF'}}>苦手</span></div>
                <Element level='bad' element={this.props.myElement[2]} />
                <Element level='bad' element={this.props.myElement[3]} />
              </td>
              <td>
                <span className='text_icon' style={{backgroundColor:'#073E77', fontSize:'0.9em', color:'#FFF'}}>苦手</span>
                <Element level='bad' element={this.props.partnerElement[2]} />
                <Element level='bad' element={this.props.partnerElement[3]} />
              </td>
            </tr>
            <tr>
              <td height={tableColHeight}>
                <div align='right'><span className='text_icon' style={{backgroundColor:'#920056', fontSize:'0.9em', color:'#FFF'}}>補完</span></div>
                <Element level='supply' element={this.props.myElement[4]} />
                <Element level='supply' element={this.props.myElement[5]} />
              </td>
              <td>
                <span className='text_icon' style={{backgroundColor:'#920056', fontSize:'0.9em', color:'#FFF'}}>補完</span>
                <Element level='supply' element={this.props.partnerElement[4]} />
                <Element level='supply' element={this.props.partnerElement[5]} />
              </td>
            </tr>
            <tr>
              <td height={tableColHeight}>
                <div align='right'><span className='text_icon' style={{backgroundColor:'#75AC00', fontSize:'0.9em', color:'#FFF'}}>自制</span></div>
                <Element level='control' element={this.props.myElement[6]} />
                <Element level='control' element={this.props.myElement[7]} />
              </td>
              <td>
                <span className='text_icon' style={{backgroundColor:'#75AC00', fontSize:'0.9em', color:'#FFF'}}>自制</span>
                <Element level='control' element={this.props.partnerElement[6]} />
                <Element level='control' element={this.props.partnerElement[7]} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default Comp;
